module.exports = __webpack_public_path__ + "static/media/cancun.27979ad1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/centers/cancun.png
// module id = 616
// module chunks = 0